export default __webpack_public_path__ + "static/media/sashimimochi2022.d3a8ccfc.png";